module.exports = __webpack_public_path__ + "static/media/cc-3.8931455a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cc-3.png
// module id = 102
// module chunks = 0